module.exports = __webpack_public_path__ + "static/media/weather.ff9a6977.png";